import Vue from "vue";
export default {
	state: {
		user: {}
	},
	mutations: {
		login(state, data) {
			console.log(data, "data");
			state.user = {...state.user, ...data};
		}
	},
	actions: {
		async login({commit}) {
			try {
				const res = await Vue.prototype.$axios({
					url: "/gateway/login?account=511659&password=19840601",
					method: "POST"
				});
				commit("login", res.data);
			} catch (e) {
				commit("login", {});
			}
		}
	},
	getters: {
		user: state => state.user
	}
};
